import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  inputFloatLabel: {
    description: 'saveFilterViewModal.inputFloatLabel',
    defaultMessage: 'View Name',
    id: 'YU9epz',
  },
  selectFilterView: {
    description: 'saveFilterViewModal.selectFilterView',
    defaultMessage: 'Select View',
    id: 'S9BkJv',
  },
  dropdownLabel: {
    description: 'saveFilterViewModal.dropdownLabel',
    defaultMessage: 'Overwrite View',
    id: '9BQRxk',
  },
  noViewNameErrorMessage: {
    description: 'saveFilterViewModal.noNameErrorMessage',
    defaultMessage: 'No name entered for view.',
    id: 'Lumdrr',
  },
  existingViewNameErrorMessage: {
    description: 'saveFilterViewModal.errorMessage',
    defaultMessage: 'This name is already taken by an existing saved view.',
    id: 'sMyQYN',
  },
  saveViewModalHeader: {
    description: 'saveFilterViewModal.title',
    defaultMessage: 'Save View',
    id: 'OT4D1r',
  },
  saveAsNewViewLabel: {
    description: 'saveFilterViewModal.saveAsNewView',
    defaultMessage: 'Save as a new view',
    id: 'GgoIVL',
  },
  overwriteExistingViewLabel: {
    description: 'saveFilterViewModal.overwriteView',
    defaultMessage: 'Overwrite an existing saved view',
    id: 'DTb23K',
  },
  cancelButtonText: {
    description: 'saveFilterViewModal.cancel',
    defaultMessage: 'Cancel',
    id: 'z4GPwN',
  },
  saveViewButtonText: {
    defaultMessage: 'Save View',
    description: 'saveFilterViewModal.saveView',
    id: 'digyTp',
  },
  saveViewErrorHeader: {
    description: 'saveFilterViewModal.error',
    defaultMessage: 'Error',
    id: 'bbcy40',
  },
});
